import { GeoAutocompleteAddress } from '@brenger/api-client';

export const jsonToQueryParams = (json: GeoAutocompleteAddress | Record<string, unknown>, prefix: string): string => {
  return Object.keys(json)
    .map(key => {
      return `${prefix}[${encodeURIComponent(key)}]=` + encodeURIComponent(String(json[key]));
    })
    .join('&');
};
